import { useGetApiUsageQuery } from '@app/services';
import { Card, Statistic, Space, Typography } from 'antd';

const { Text } = Typography;

interface Props {
    appName: string;
}

export default function ApiUsageCard({ appName }: Props) {
    const { data, isLoading } = useGetApiUsageQuery(appName);

    if (isLoading || !data) return null;

    const today = data[data.length - 1]?.count ?? 0;
    const weekTotal = data.slice(-7).reduce((sum, d) => sum + d.count, 0);
    const monthTotal = data.reduce((sum, d) => sum + d.count, 0);
    const maxCount = Math.max(...data.map(d => d.count), 1);

    // Skip rendering if no usage at all
    if (monthTotal === 0) return null;

    return (
        <Card title="API Usage">
            <Space size="large" style={{ marginBottom: 16 }}>
                <Statistic title="Today" value={today} />
                <Statistic title="Last 7 days" value={weekTotal} />
                <Statistic title="Last 30 days" value={monthTotal} />
            </Space>

            {/* Simple bar chart */}
            <div>
                <div style={{
                    display: 'flex',
                    alignItems: 'flex-end',
                    gap: 2,
                    height: 80,
                    borderBottom: '1px solid #f0f0f0',
                }}>
                    {data.map((d) => (
                        <div
                            key={d.date}
                            title={`${d.date}: ${d.count} requests`}
                            style={{
                                flex: 1,
                                height: `${Math.max((d.count / maxCount) * 100, d.count > 0 ? 4 : 0)}%`,
                                backgroundColor: '#1677ff',
                                borderRadius: '2px 2px 0 0',
                                minHeight: d.count > 0 ? 2 : 0,
                            }}
                        />
                    ))}
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 4 }}>
                    <Text type="secondary" style={{ fontSize: 11 }}>{data[0]?.date}</Text>
                    <Text type="secondary" style={{ fontSize: 11 }}>{data[data.length - 1]?.date}</Text>
                </div>
            </div>
        </Card>
    );
}
